import { render } from "./GameRow.vue?vue&type=template&id=1d53a031"
import script from "./GameRow.vue?vue&type=script&lang=js"
export * from "./GameRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__